import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ChannelBootstrapService } from '../services/channel-bootstrap.service';
import { OnlyIndicationService } from '../services/only-indication.service';
import { UtmPreservationService } from '../services/utm-preservation.service';

@Injectable({
  providedIn: 'root',
})
export class OnlyIndicationGuard implements CanActivate, CanActivateChild {
  private router = inject(Router);
  private onlyIndicationService = inject(OnlyIndicationService);
  private utmPreservationService = inject(UtmPreservationService);
  private channelBootstrapService = inject(ChannelBootstrapService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAccess$(state.url);
  }

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAccess$(state.url);
  }

  private checkAccess$(url: string): Observable<boolean | UrlTree> {
    // Wait for channel (utm_source) so onlyIndication is known before allowing any route.
    return this.channelBootstrapService.ensureLoaded().pipe(
      map(() => this.checkAccess(url))
    );
  }

  private checkAccess(url: string): boolean | UrlTree {
    if (!this.onlyIndicationService.isOnlyIndicationActive) {
      return true;
    }

    const targetPath = url.split('?')[0];

    if (targetPath === '/indica') {
      return true;
    }

    const queryParams =
      this.utmPreservationService.addPreservedUtmToQueryParams({});
    const tree = this.router.parseUrl('/indica');
    tree.queryParams = { ...tree.queryParams, ...queryParams };
    return tree;
  }
}
